import React from 'react';
import { useAppConfig } from '../../contexts/AppConfigContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { appName } = useAppConfig();

  return (
    <footer className="bg-white border-t border-slate-200 py-4">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-slate-500">
          <p>© {currentYear} {appName}. Exam preparation platform.</p>
          <div className="flex items-center gap-3">
            <span className="text-slate-400">v2.1.0</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
